export default "__VITE_ASSET__BLr9Chjl__"